module.exports = __webpack_public_path__ + "static/media/Tinos.ed1cd319.webp";